// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"cea558be","316":"82124300","473":"03a03b4a","896":"40251cb1"}[chunkId] + ".chunk.js";
};